import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

/**
 * `/submit-editing-request/:id` used to be a second copy of the review
 * decision: it accepted or rejected the *project* (UpdateRequestStatus),
 * while Project details decides on each *revision* (UpdateRevisionStatus),
 * so the two pages updated different records and could disagree. It never
 * let the creator edit a draft. Old links and bookmarks now land on Project
 * details, where the review, the decision and closing the project live.
 */
const EditProjectsForCreator: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  return <Navigate replace to={id ? `/project-details/${encodeURIComponent(id)}` : '/my-projects'} />;
};

export default EditProjectsForCreator;
